import styled from 'styled-components';

import ActionButton from 'components/action-button';
import { ModalContent } from 'components/modal';

export const HeaderCaption = styled.div`
  color: ${Styles.color.black};
  font-weight: normal;
  letter-spacing: 0;
  text-align: center;
  padding-top: 2rem;
  h2 {
    font-family: ${Styles.fontFamily.base};
    margin: 0.75rem 0 0;
    text-transform: uppercase;
  }
  h5 {
    font-family: ${Styles.fontFamily.body};
    margin: 0;
    text-transform: none;
  }
  ${Styles.desktop`
    line-height: 1;
  `}
`;

export const GeolocationImageContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0.5rem 0rem;
  width: 50px;
  height: 80px;
`;

export const ModalButton = styled(ActionButton)`
  margin: 0 auto 0.625rem;
`;

export const ModalButtonAlt = styled(ModalButton)`
  background-color: transparent;
  color: ${Styles.color.grey.one};
  font-family: ${Styles.fontFamily.base};
  margin: 0 auto;
  &:hover {
    background-color: transparent;
    text-decoration: underline;
  }
  ${Styles.desktop`
    max-width: 18.75rem;
  `}
`;

export const ContentContainer = styled(ModalContent)`
  padding-bottom: 2rem;
`;
